﻿import { mapGetters, mapState } from 'vuex'; 

  export default {
name: 'ca-loader', 
data: () => ({

}),  
methods: {
},
created: function() {    
},
computed:
    Object.assign(
    mapState({       
        pageLoader: state => state.creditaccount.pageLoader

    }),
    mapGetters({      
    }))
}
